import {Component} from 'ng-metadata/core';
import {MediaQueries} from "../../infra/mediaQueries.service";
import {NewspapersService} from "../newspapers.service";

@Component({
    selector: 'prm-search-result-title',
    templateUrl: 'components/newspapers/searchResultTitle/search-result-title.html',
})

export class PrmSearchResultTitle{
    constructor(private mediaQueries: MediaQueries,
                private newspapersService: NewspapersService) {
    }

    private get featuredTitle() {
        return this.newspapersService.featuredTitle;
    }

    private get featuredDescription() {
        return this.newspapersService.featuredDescription;
    }




}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/searchResultTitle/searchResultTitle.directive.ts